define([
    'vue',
    'web/i18n/index',
    'WebCommon/mixin/page',
    'index2024-buyChannel/component/page-content',

    // 'WebCommon/init'
], function(
    Vue,
    i18n,
    PageMixin,

    PageContent
){
    var app = new Vue({
        mixins: [PageMixin],
        components: {
            PageContent: PageContent
        },
        i18n: i18n
    });
    app.$mount('#app');

});



//////////////////
// WEBPACK FOOTER
// ./index2024-buyChannel/main.js
// module id = 342
// module chunks = 5